import { Locale } from 'modules/i18n';

export const referralCodeInputTranslation = {
  [Locale.en]: {
    appliedCodeMessage: 'Recently applied referral code',
    placeholder: 'Enter referral code',
  },
};
